export const LocalStorageKeys = {
	USER_PREFERENCES: 'userPreferences',
	USER_CANVAS_PREFERENCES: 'userCanvasPreferences',
	ALL_CANVAS_PREFERENCES: 'allCanvasPreferences',
	MAX_Y_COORDINATE: 'maxYCoordinate',
	LANDING_PAGE_TO_STUDIO_TRIGGER: 'landingToStudioTrigger',
	SHOW_CANVAS_GUIDE: 'showCanvasGuide',
	FLOATING_ALERT: 'floatingAlert',
};
